import { render, staticRenderFns } from "./glbankcash.vue?vue&type=template&id=4f265412&scoped=true"
import script from "./glbankcash.vue?vue&type=script&lang=js"
export * from "./glbankcash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f265412",
  null
  
)

export default component.exports